import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Grid, Row } from 'react-bootstrap';
import CommunityMessageContainer from 'containers/CommunityMessageContainer';
import Game from 'components/Game';
import GameChat from 'components/GameChat';
import Feed from 'containers/Feed';
import ErrorNotificationPage from 'components/ErrorNotificationPage';
import ErrorBoundary from 'containers/ErrorBoundary';
import './GamePage.css';

class GamePage extends Component {
  constructor(props) {
    super(props);

    this.onGameStartError = this.onGameStartError.bind(this);

    this.state = {
      error: undefined
    };
  }

  onGameStartError(message) {
    this.setState({
      error: message
    });
  }

  render() {
    const { match } = this.props;
    const gameName = match.params.game;

    return (
      <ErrorNotificationPage notificationMessage={this.state.error}>
        <Helmet>
          <title>Game</title>
        </Helmet>
        <Grid className="main-container game-container">
          <Row className="game-wrapper">
            <div className="col left-panel">
              <ErrorBoundary>
                <Feed location={this.props.location} narrow />
              </ErrorBoundary>
              <ErrorBoundary>
                <GameChat gameName={gameName} room={gameName} />
              </ErrorBoundary>
            </div>
            <div className="col right-panel">
              <ErrorBoundary>
                <CommunityMessageContainer large />
              </ErrorBoundary>
              <ErrorBoundary>
                <Game onError={this.onGameStartError} gameName={gameName} />
              </ErrorBoundary>
            </div>
          </Row>
        </Grid>
      </ErrorNotificationPage>
    );
  }
}

export default GamePage;



// WEBPACK FOOTER //
// ./src/containers/GamePage/index.js